import { render, staticRenderFns } from "./QuickTipsDirectMatchConfiguration.vue?vue&type=template&id=2be66aa8&scoped=true&"
import script from "./QuickTipsDirectMatchConfiguration.vue?vue&type=script&lang=js&"
export * from "./QuickTipsDirectMatchConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be66aa8",
  null
  
)

export default component.exports